import { useGetAccounts } from '@api/lendingAPI/lapiHooks';
import { definitions } from '@iwoca/lapi-client/edge';

export const useGetANTFormalOffers = () => {
    const { data: accounts, isLoading: loadingAccounts } = useGetAccounts();

    const antOffers: definitions['loan_account']['latest_formal_offer'][] =
        accounts?.accounts.flatMap((account) => {
            if (
                account.loan_offer_id !== account.latest_formal_offer?.offer_id
            ) {
                return account.latest_formal_offer?.is_valid
                    ? account.latest_formal_offer
                    : [];
            }
            return [];
        }) || [];

    return {
        offers: antOffers,
        isLoading: loadingAccounts
    };
};
